import api from "./Api";

class HeartbeatService {
  async sendHeartbeat(data: { article_id?: number } = {}) {
    try {
      const response = await api.post(`dashboards/heartbeat`, data);
      return [response?.data, undefined];
    } catch (e: any) {
      return [undefined, e?.response?.data?.message || "Erro ao enviar heartbeat"];
    }
  }
}

export default new HeartbeatService();
